import {
  Box,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  styled,
} from "@mui/material";
import { formattedDate, formattedShortDate, newsData } from "../../helper";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    right: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    //backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  [theme.breakpoints.down("md")]: {
    width: "95%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const NewsCard = ({ title, category, publishedAt, image, handleNewsDetails }) => (

  <Card
    sx={{
      height: "260px",
      position: "relative",
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      cursor: 'pointer'
    }}
    onClick={() => handleNewsDetails()}
  >
    <CardMedia
      component="img"
      height="200"
      image={image}
      alt={title}
      sx={{ opacity: 0.7 }}
    />
    <CardContent
      sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        padding: "16px",
      }}
    >
      <Typography
        variant="h6"
        component="div"
        sx={{ color: "white", fontWeight: "bold", fontSize: "14px" }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: "#8C8CC2", opacity: 0.8, fontSize: "12px" }}
        >
          #{category}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "#8C8CC2", opacity: 0.8, fontSize: "12px" }}
        >
          {publishedAt}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

const InTheNews = () => {
  const navigate = useNavigate();
  const [newsData, setNewsData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);

  const getArticles = async (pageNumber = 1) => {
    try {
      const response = await axios.get(
        `https://dev.ienergydigital.com/task-api/api/newsroom/articles?page=${pageNumber}&limit=12`
      );

      const formattedArticles = response.data.data.articles.map((item) => ({
        slug: item.slug,
        id: item.id,
        title: item.title,
        category: item?.sourceName,
        description: item.excerpt,
        image: item.heroImageUrl,
        slug: item.slug,
        sourceName: item.sourceName,
        readTime: item.readTimeMinutes,
        publishedAt: formattedShortDate(item?.publishedAt),
        isFeatured: item.isFeatured,
      }));

      setNewsData(formattedArticles);
      setPagination(response.data.data.pagination);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getArticles(page);
  }, [page]);



  const handleNewsDetails = (slug) => {
    if (!slug) return;

    navigate(`/newsroom-details/${slug}`);
  };

  return (
    <MainContainer>
      <ContentWrapper>
        <Box
          sx={{
            width: "100%",
            minHeight: "500px",
            margin: "0 auto",
            padding: 4,
            borderRadius: "16px",
            border: "1px solid transparent",
            borderImageSlice: 1,
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              borderRadius: "16px",
              border: "1px solid transparent",
              background:
                "radial-gradient(80.38% 222.5% at -13.75% -12.36%, #98F9FF 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(80.69% 208.78% at 108.28% 112.58%, #EABFFF 0%, rgba(135, 38, 183, 0) 100%)",
              WebkitMask:
                "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
              WebkitMaskComposite: "xor",
              maskComposite: "exclude",
              pointerEvents: "none",
            },
            background:
              "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)",
            backdropFilter: "blur(10px)",
            backgroundColor: "rgba(13, 15, 35, 0.9)",
          }}
        >

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                <Typography sx={{ fontWeight: 700, fontSize: '32px', color: '#FFFFFF' }}>In the News!</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <Grid container spacing={2}>
                {newsData?.map((news, index) => (
                  <Grid item xs={12} sm={4} key={index}>
                    <NewsCard {...news} handleNewsDetails={() => handleNewsDetails(news?.slug)} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </ContentWrapper>
    </MainContainer>
  );
};

export default InTheNews;
